import { render, staticRenderFns } from "./ItemListRigaSpedizione.vue?vue&type=template&id=44326448"
import script from "./ItemListRigaSpedizione.vue?vue&type=script&lang=ts"
export * from "./ItemListRigaSpedizione.vue?vue&type=script&lang=ts"
import style0 from "./ItemListRigaSpedizione.vue?vue&type=style&index=0&id=44326448&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44326448')) {
      api.createRecord('44326448', component.options)
    } else {
      api.reload('44326448', component.options)
    }
    module.hot.accept("./ItemListRigaSpedizione.vue?vue&type=template&id=44326448", function () {
      api.rerender('44326448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListRigaSpedizione.vue"
export default component.exports